import { render, staticRenderFns } from "./LxDatepicker.vue?vue&type=template&id=536d18a4&scoped=true&"
import script from "./LxDatepicker.vue?vue&type=script&lang=js&"
export * from "./LxDatepicker.vue?vue&type=script&lang=js&"
import style0 from "./LxDatepicker.vue?vue&type=style&index=0&id=536d18a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536d18a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDialog,VDivider,VIcon,VTextField})
